import { render, staticRenderFns } from "./ImageCapture.vue?vue&type=template&id=53b6f6d6&scoped=true&"
import script from "./ImageCapture.vue?vue&type=script&lang=js&"
export * from "./ImageCapture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b6f6d6",
  null
  
)

export default component.exports